<template>
  <div class="step step1 active">
    <div class="font-medium text-xl lg1024:text-3xl" data-qa="step0-oldstep1-title">
      {{ $t('unauth_step1') }}
    </div>
    <div class="stepContent">
      <MembershipBlock @change="handleChange" />
    </div>
  </div>
</template>

<script setup>
import MembershipBlock from './MembershipBlock.vue'

const emit = defineEmits(['change'])
function handleChange(value) {
  emit('change', value)
}
</script>
